<template>
  <div>
    <my-table :title="title"
              :searchParams="searchParams"
              :isAdd="isAdd"
              :tableData="tableData"
              @pageNumChange="pageNumChange"
              @search="search"
              @keyup.enter.native="keyup()" @add="addMerchants">
      <div slot="table">
        <merchants-table :tableData="tableData.list" @del="del"></merchants-table>
      </div>
    </my-table>
  </div>
</template>

<script>
  import MerchantsTable from "./MerchantsTable";
  import MyTable from "../../components/content/myTable/MyTable";
  import {getMerchantsBySearch,newVue,delByMerchantsId} from "../../network/merchants";

  export default {
    name: "MerchantsList",
    components: {MerchantsTable, MyTable},
    data(){
      return {
        title: "农基商列表",
        //搜索条件
        searchParams:[
          {
            key:"merchantsClassify",
            value:"农基商类型"
          },
          {
            key:"merchantsName",
            value:"农基商名称"
          },
          {
            key:"detailAddress",
            value:"农基区域"
          },
          {
            key:"name",
            value:"联系人"
          }
        ],
        isAdd: true,
        tableData:{},
        searchItems:{}
      }
    },
    created() {
      newVue.obj = this;
      this.common.HeaderLocationTwo.href =  "/merchants/list";
      this.common.HeaderLocationTwo.name = "农基商资料管理"
      this.common.HeaderLocationThree.name = "农基商列表"
      getMerchantsBySearch().then(res => {
        this.tableData = res.data;
      })
    },
    methods:{
      pageNumChange(pageNum){
        this.searchEasy(this.searchItems,pageNum);
      },
      search(searchItems){
        this.searchItems = searchItems;
        this.searchEasy(searchItems)
      },
      searchEasy(searchItems,pageNum){
        let merchantsClassify = null;
        let merchantsName = null;
        let detailAddress = null;
        let name = null;
        for (let i = 0;i<searchItems.length;i++){
          if (searchItems[i].value === "merchantsClassify"){
            merchantsClassify = searchItems[i].input
          }else if (searchItems[i].value === "merchantsName"){
            merchantsName = searchItems[i].input
          }else if (searchItems[i].value === "detailAddress"){
            detailAddress = searchItems[i].input
          }else if (searchItems[i].value === "name"){
            name = searchItems[i].input
          }
        }
        getMerchantsBySearch(merchantsClassify,merchantsName,detailAddress,name,pageNum).then(res => {
          this.tableData = res.data
        })
      },
      keyup(){
        this.searchEasy(this.searchItems);
      },
      del(id){
        delByMerchantsId(id).then(res => {
            this.searchEasy(this.searchItems);
          }
        )
      },
      addMerchants(){
        this.$router.push("insert/")
      }
    }
  }
</script>

<style scoped>

</style>
